module.exports = "/_next/static/resources/array-6f2f95bda6c8882fd5aa4fd13f26249a.webp";